import { render, staticRenderFns } from "./Depot.vue?vue&type=template&id=0c2c5bd2&"
import script from "./Depot.vue?vue&type=script&lang=js&"
export * from "./Depot.vue?vue&type=script&lang=js&"
import style0 from "./Depot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports